type ShouldShowProfileAvatarParams = {
  isSessionLoading: boolean
  avatarSourceUrl: string | undefined
  isImagePending: boolean
}

/** Defer profile avatar until session data and image (if any) are ready. */
export function shouldShowProfileAvatar({
  isSessionLoading,
  avatarSourceUrl,
  isImagePending,
}: ShouldShowProfileAvatarParams): boolean {
  if (isSessionLoading) {
    return false
  }
  if (avatarSourceUrl && isImagePending) {
    return false
  }
  return true
}
